import { FileExcelOutlined } from "@ant-design/icons";
import { StyledExcelButton } from "./styles";

interface ExcelButtonComponentProps {
    onClick: () => void | Promise<void>;
    loading?: boolean;
    disabled?: boolean;
    title?: string;
}

const ExcelButtonComponent = ({
	onClick,
	loading = false,
	disabled = false,
	title = "Excel İndir",
}: ExcelButtonComponentProps) => {
	return (
		<StyledExcelButton
			type="primary"
			title={title}
			icon={<FileExcelOutlined />}
			loading={loading}
			disabled={disabled}
			onClick={onClick}
		/>
	);
};

export default ExcelButtonComponent;
